import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "autoClose"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useEffect } from 'react';
import { ComponentWrapper } from "./ComponentWrapper";
import { Tooltip } from "../components";
import { useConfiguration, usePersonalBeautyStore, usePersonalBeautyStoreUserInfo } from "../contexts";
import { ReferralType } from "../models";
import { getLiveStreamingStateByVideoConfig } from "../utils";

/**
 * Time after which will be tooltip automatically closed
 */
import { jsx as _jsx } from "react/jsx-runtime";
var AUTO_CLOSE_TIME = 5000; // ms

export var TooltipContainer = function TooltipContainer(_ref) {
  var _pbsData$application$, _pbsData$application, _pbsData$application$2, _pbsData$beautyStore, _pbsData$beautyStore$, _storeInfo$type;
  var onClick = _ref.onClick,
    _ref$autoClose = _ref.autoClose,
    autoClose = _ref$autoClose === void 0 ? true : _ref$autoClose,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePersonalBeautySto = usePersonalBeautyStore(),
    tooltipWasShown = _usePersonalBeautySto.tooltipWasShown,
    setTooltipWasShown = _usePersonalBeautySto.setTooltipWasShown,
    pbsData = _usePersonalBeautySto.pbsData,
    storeInfo = _usePersonalBeautySto.storeInfo;
  var _useConfiguration = useConfiguration(),
    isEnabled = _useConfiguration.isEnabled;
  var _usePersonalBeautySto2 = usePersonalBeautyStoreUserInfo(),
    firstName = _usePersonalBeautySto2.firstName,
    lastName = _usePersonalBeautySto2.lastName,
    photoUrl = _usePersonalBeautySto2.photoUrl;
  var _ref2 = (_pbsData$application$ = pbsData === null || pbsData === void 0 ? void 0 : (_pbsData$application = pbsData.application) === null || _pbsData$application === void 0 ? void 0 : (_pbsData$application$2 = _pbsData$application.videoShopping) === null || _pbsData$application$2 === void 0 ? void 0 : _pbsData$application$2.configuration) !== null && _pbsData$application$ !== void 0 ? _pbsData$application$ : {},
    isVideoShoppingEnabled = _ref2.isVideoShoppingEnabled;
  var currentVideoShow = pbsData === null || pbsData === void 0 ? void 0 : (_pbsData$beautyStore = pbsData.beautyStore) === null || _pbsData$beautyStore === void 0 ? void 0 : (_pbsData$beautyStore$ = _pbsData$beautyStore.videoShows) === null || _pbsData$beautyStore$ === void 0 ? void 0 : _pbsData$beautyStore$.find(function (show) {
    return show === null || show === void 0 ? void 0 : show.isCurrent;
  });
  /**
   * Multiple conditions connected into one, controls rendering of tooltip
   */
  var shouldRender = Boolean(isEnabled && (firstName || lastName) && !tooltipWasShown);

  // Custom callback, if user clicks tooltip then we trigger onClick and hide it
  var onClickCallback = useCallback(function (e) {
    if (typeof onClick === 'function') {
      onClick(e);
    }
    // Just hide tooltip right away if user clicked
    setTooltipWasShown(true);
  }, [onClick, setTooltipWasShown]);

  // Autoclose after defined time if conditions are met
  useEffect(function () {
    var timer;

    // We only set timer if tooltip will render, was not shown before on device and if auto-close is enabled
    if (shouldRender && autoClose) {
      timer = setTimeout(function () {
        return setTooltipWasShown(true);
      }, AUTO_CLOSE_TIME);
    }
    return function () {
      return clearTimeout(timer);
    };
  }, [shouldRender, autoClose, setTooltipWasShown]);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ComponentWrapper, {
    children: /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, props), {}, {
      referralType: (_storeInfo$type = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.type) !== null && _storeInfo$type !== void 0 ? _storeInfo$type : ReferralType.None,
      firstName: firstName,
      lastName: lastName,
      photoUrl: photoUrl,
      liveStreamingState: getLiveStreamingStateByVideoConfig({
        isVideoShoppingEnabled: isVideoShoppingEnabled,
        currentVideoShow: currentVideoShow
      }),
      onClick: onClickCallback
    }))
  });
};